<template>
  <v-card color="#EFF3F8" outlined >
    <div class="px-4 card-container text-selection">
      <div>
        <v-checkbox
          v-show="disableAcoesGuias && canDoActions"
          :input-value="isGuiaSelected"
          @click.stop="clickGuia"
        />
      </div>
      <div v-if="guia.isBaixa">
        <p>GUIA DE BAIXA </p>
      </div>
      <div v-if="!guia.isBaixa">
        <p class="status-title">Nº GUIA PRESTADOR </p>
        <p class="font-weight-bold">{{ guia.numeroGuiaPrestador }}</p>
      </div>
      <div v-if="!guia.isBaixa">
        <p class="status-title">BENEFICIÁRIO</p>
        <div style="width: 151px;">
          <p class="font-weight-bold" style="font-size: 0.9rem;">{{ guia.nomeBeneficiario }}</p>
          <p class="font-weight-bold">{{ guia.numeroCarteira }}</p>
        </div>
      </div>
      <div>
        <p class="status-title">INFORMADO </p>
        <p class="font-weight-bold text-no-wrap">R$ {{ guia.valorInformado | formatPrice }}</p>
      </div>
      <div>
        <p class="status-title">PAGO </p>
        <p class="font-weight-bold success--text text-no-wrap">R$ {{ guia.valorPago | formatPrice }}</p>
      </div>
      <div>
        <p class="status-title">GLOSADO </p>
        <p class="font-weight-bold red--text text-no-wrap">R$ {{guia.valorGlosado | formatPrice }}</p>
      </div>
      <div>
        <p class="status-title">GLOSADO CONCILIADO </p>
        <p class="font-weight-bold red--text text-no-wrap">R$ {{guia.valorGlosadoConciliado | formatPrice }}</p>
      </div>
      <div>
        <p class="font-weight-bold">Itens</p>
        <p class="font-weight-600 itens-text">Recurso: {{ guia.quantidadeItensRecurso }}</p>
        <p class="font-weight-600 itens-text">Estorno: {{ guia.quantidadeItensEstorno }}</p>
      </div>
      <div class="bars">
        <p class="status-title font-weight-bold">Conciliação</p>
        <div>
          <PercentBarGroup
            style="pointer-events: all"
            :progressBars="progressBars"
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import PercentBarGroup from '../../common/PercentBarGroup.vue'
import { getItemPercentMessages, getValorPercentMessages } from '../../../libs'

export default {
  props: {
    guia: Object,
    selectedGuias: Array,
    disableAcoesGuias: Boolean,
    canDoActions: Boolean
  },
  components: {
    PercentBarGroup
  },
  methods: {
    clickGuia () {
      const params = { guiaId: this.guia.id, checked: this.isGuiaSelected }
      this.$emit('checkboxClick', params)
    }
  },
  computed: {
    isGuiaSelected () {
      return this.selectedGuias.includes(this.guia.id)
    },
    valoresConciliacaoTexts () {
      return getValorPercentMessages(
        this.guia.valorPago + this.guia.valorGlosado,
        this.guia.valorItensConciliacaoAutomatica,
        this.guia.valorItensConciliacaoManual
      )
    },
    itensConciliacaoTexts () {
      return getItemPercentMessages(
        this.guia.quantidadeItens,
        this.guia.quantidadeItensConciliacaoAutomatica,
        this.guia.quantidadeItensConciliacaoManual
      )
    },
    progressBars () {
      return [
        {
          label: 'Valor',
          total: this.guia.status === 'conciliacaoAutomatica' ? 0 : this.guia.percentualConciliadoValor,
          automatica: this.guia.percentualConciliadoValorAutomatico,
          manual: this.guia.percentualConciliadoValorManual,
          textAutomatica: this.valoresConciliacaoTexts.textAutomatica,
          textManual: this.valoresConciliacaoTexts.textManual,
          textRestante: this.valoresConciliacaoTexts.textRestante
        },
        {
          label: 'Itens',
          total: this.guia.status === 'conciliacaoAutomatica' ? 0: this.guia.percentualConciliadoQuantidade,
          automatica: this.guia.percentualConciliadoQuantidadeAutomatico,
          manual: this.guia.percentualConciliadoQuantidadeManual,
          textAutomatica: this.itensConciliacaoTexts.textAutomatica,
          textManual: this.itensConciliacaoTexts.textManual,
          textRestante: this.itensConciliacaoTexts.textRestante
        }
      ]
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.text-selection {
  user-select: text;
}
.itens-text {
  margin: 4px 0;
}
.status-title {
  margin-bottom: 8px;
}
.icon {
  display: flex;
  justify-content: center;
}
.card-container {
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.v-tooltip__content {
  background-color: #FFFFFF !important;
  border: 1px solid #CFCFCF !important;
}
.font-weight-600 {
  font-weight: 600;
}
.card {
  align-items: center;
}
.bars {
  width: 15%;
}
</style>
